import type { UnpaidLessonVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const teacherRetrieveUnpaidLessons = createApiThunk<UnpaidLessonVM[], void>(
  "unpaidLessons/teacherRetrieveUnpaidLessons",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.getUnpaidLessons();
  },
);
